<template>
  <div class="pip-table" v-if="params.node_form_id" :key="params.node_form_id">
    <table :class="isAll ? 'table-top' : 'table-bottom'" :style="{'background-image': 'url(' + watermark +')', 'width': ((params.node_form_id != '2' ? width1 : width2) + pplTyped.length*100) + 'px'}">
      <thead v-if="!isAll">
        <tr>
          <td class="left-th" width="106">所属公司</td>
          <td class="left-th" width="86">产品名称</td>
          <td class="left-th" width="86" v-show="isAll && params.node_form_id != '2'">技术</td>
          <td class="left-th" width="102" v-show="isAll && params.node_form_id != '2'">靶点</td>
          <td class="left-th" width="86" v-show="isAll">适应症</td>
          <!-- <td class="left-th" width="86" v-show="isAll && params.node_form_id != '2'">权利区域</td> -->
          <!-- <td class="left-th" width="86" v-show="isAll && params.node_form_id != '2'">来源</td> -->
          <td class="right-th" width="100" v-for="type in pplTyped" :key="type.id">{{type.name}}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item,index in (!isAll ? ppl_list_copy : ppl_list)" :key="index" v-show="index < (isAll ? ppl_list.length : 6)">
          <td class="left-td" width="106">
            <div class="td-content"><a @click.stop="goDetail(item.entity_uid, item.entity_type)" class="short_name">{{item.short_name}}<i class="short_name_icon"></i></a></div>
          </td>
          <td class="left-td" width="86">
            <div class="td-content" >{{item.product_name}}</div>
          </td>
          <td class="left-td" width="86" v-show="isAll && params.node_form_id != '2'">
            <div class="td-content">{{item.technology | array2string}}</div>
          </td>
          <td class="left-td" width="102" v-show="isAll && params.node_form_id != '2'">
            <div class="td-content">
              <div v-for="itemtarget,idx2 in item.target" :key="idx2" class="target-item">{{itemtarget.short_name}}</div>
            </div>
          </td>
          <td class="left-td" width="86" v-show="isAll">
            <div class="td-content">{{item.indication | array2string}}</div>
          </td>
          <!-- <td class="left-td" width="86" v-show="isAll && params.node_form_id != '2'">
            <div class="td-content">{{item.area | array2string}}</div>
          </td>
          <td class="left-td" width="86" v-show="isAll && params.node_form_id != '2'">
            <div class="td-content">{{item.source | array2string}}</div>
          </td> -->
          <td :colspan="pplTyped.length" class="right-td" width="100">

            <div class="line" :style="{'width': nodes_arr(item.nodes) * 100 + 'px'}"></div>
            <div class="pipelines" :style="{'grid-template-columns': 'repeat(' + pplTyped.length + ', 100px)'}">
              <div class="pipeline" v-for="item2,idx2 in item.nodes" :key="idx2">
                <Tooltip :placement="index > 0 ? (pplTyped.length != idx2+1 ? 'top' : 'top-end') : 'left'" v-if="item2.news_topic.length > 0">
                  <div  :class="'circle status'+ item2.node_status" @click.stop="haddleClickDetail(item2)">{{item2.news_topic.length}}</div>
                  <div :class="'time status'+ item2.node_status">{{item2.node_time | time_moment('YYYY.M')}}</div>
                  <div slot="content">
                    <div class="news-topic" v-if="item2.news_topic.length == 1" @click.stop="haddleClickDetail(item2)">{{item2.news_topic[0].title | len20}}<span>查看详情</span></div>
                    <div class="news-topic2" v-else @click.stop="haddleClickDetail(item2)">
                      <p>{{item2.type_id | dealName(pplType, 'id', 'name')}}：{{item2.news_topic.length}}条快讯</p>
                      <div>查看详情</div>
                    </div>  
                  </div>
                </Tooltip>
                <div v-if="item2.news_topic.length == 0 && item2.type_id">
                  <div  :class="'circle status'+ item2.node_status"></div>
                  <div :class="'time status'+ item2.node_status">{{item2.node_time | time_moment('YYYY.M')}}</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['getImageBlob', 'pplItem', 'params', 'pplType', 'isAll', 'nodeFormId'],
  computed: {
    watermark() {
      return !this.$store.state.theme_switch ? this.watermark_white : this.watermark_gray
    },
    nodes_arr() {
      return function (arr) {
        var larr = arr.filter(a => a.news_topic.length > 0)
        var nodes_len = larr.map(item => item.type_id)
        var nodes = arr.filter((item) => nodes_len.indexOf(item.type_id) != -1)
        return this.pplTyped.findIndex(e => e.id == nodes[nodes.length - 1]['type_id']) 
      }
    },
    // nodes_arr() {
    //   return function (arr) {
    //     var larr = arr.filter(a => a.news_topic.length > 0)
    //     var nodes_len = larr[larr.length - 1]['type_id']
    //     return arr.slice(0, nodes_len)
    //   }
    // },
    ppl_list() {
      let arr = this.pplItem.content.filter(item => {
        if (this.params.entity_uid) {
          return item.entity_uid == this.params.entity_uid
        } else {
          return true
        }
      })
      let arr2 = arr.filter(item => {
        if (this.params.technology) {
          return item.technology.findIndex(a => a == this.params.technology) > -1
        } else {
          return true
        }
      })
      let arr3 = arr2.filter(item => {
        if (this.params.indication) {
          return item.indication.findIndex(a => a == this.params.indication) > -1
        } else {
          return true
        }
      })
      let arr4 = arr3.filter(item => {
        if (this.params.target) {
          return item.target.findIndex(a => a.id == this.params.target) > -1
        } else {
          return true
        }
      })
      let arr5 = arr4.filter(item => {
        if (this.params.node_form_id) {
          return item.node_form_id == this.params.node_form_id
        } else {
          return true
        }
      })
      let arr6 = arr5.filter(item => {
        if (this.params.node_id ) {
          let nodes = item.nodes.filter(i => i.type_id)
          let node = nodes.length > 0 ? nodes[nodes.length - 1] : {}
          return node.type_id == this.params.node_id
        } else {
          return true
        }
      })
      return arr6
    },
    ppl_list_copy() {
      let srr = this.pplItem.content.filter(item => {
        if (!this.isAll) {
          return item.node_form_id == this.nodeFormId
        } else {
          return true
        }
      })
      return srr
    }
  },
  watch:{
    'params.node_form_id'(val){
      if(val){
        if(this.isAll){
          this.pplTyped = this.pplType.filter(e =>e.pipeline_node_form_id == this.params.node_form_id)
        }else{
          this.pplTyped = this.pplType.filter(e =>e.pipeline_node_form_id == this.nodeFormId)
        }
      }
    }
  },
  data() {
    return {
      pplTyped: [],
      watermark_white: '',
      watermark_gray: '',
      width1: this.isAll ? 468 : 194,
      width2: this.isAll ? 280 : 194,
    }
  },
  methods: {
    haddleClickDetail(item) {
      if (item.news_topic.length == 1) {
        const href = this.$store.state.index2_path + '/newsDetail/' + item.news_topic[0].uid
        window.open(href, "_blank");
      } else {
        this.$emit('haddleMoreNewTopic', item)
      }
    },
    goDetail(uid, type) {
      if (type == 1) {
        const {
          href
        } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else if (type == 0) {
        const {
          href
        } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      }
    }
  },
  mounted() {
    this.getImageBlob(this.$store.state.static_img_url+'pic/watermark-white.png', (url) => {
      this.watermark_white = url
    })
    this.getImageBlob(this.$store.state.static_img_url+'pic/watermark-gray.png', (url) => {
      this.watermark_gray = url
    })
  }
}
</script>
<style lang="stylus" scoped>
.pip-table
  max-width calc(100% - 4px)
  .top-header
    position absolute 
    top 0
    left 0
  .table-top 
    border-top 0
    border-right 0
  .table-bottom 
    cursor pointer
  table
    border 1px solid
    table-layout fixed
    display block
    commonBorderColor(#515a6e, #E9E9E9)
    commonBgColor(rgba(50, 54, 70, 1), rgba(255, 255, 255, 1))
    // commonBgImg('~pic/watermark-white.png', '~pic/watermark-gray.png')
    td
      height 60px
      commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
      &.left-th
        padding 0 8px
        &:first-of-type
          padding-left 20px
        &+.right-th
          border-left 1px solid
          commonBorderColor(#515a6e, #E9E9E9)
      &.right-th
        text-align center
      a
        color #FA5A00
        &:hover
          color #FFA050
    thead
      td
        commonBgColor(rgba(42, 47, 66, 1), rgba(255, 250, 245, 1))
    tbody
      display block
      td
        border-top 1px solid
        commonBorderColor(#515a6e, #E9E9E9)
        padding 6px 0
        &.left-td
          &:first-of-type
            .td-content
              padding-left 20px
              .short_name
                .short_name_icon
                  border solid #FA5A00
                  border-width 0 1px 1px 0
                  display inline-block
                  padding 2px
                  transform rotate(-45deg)
                  -webkit-transform translate(2px, -1.5px) rotate(-45deg)
                &:hover
                  .short_name_icon
                    border-color #ffa050
          &+.right-td
            border-left 1px solid
            commonBorderColor(#515a6e, #E9E9E9)
          .td-content
            padding 0 6px
            word-break break-all
            line-height 16px
            .target-item+.target-item
              margin-top 4px
        &.right-td
          position relative
          line-height 1
          .pipelines
            display grid
            .pipeline
              position relative
              
              >>> .ivu-tooltip
                width 100%
                .ivu-tooltip-inner
                  background #404040
                  .news-topic
                    width 172px
                    white-space normal
                    min-height 35px
                    span
                      float right
                      color #FA5A00
                      cursor pointer
                  .news-topic2
                    text-align center
                    div
                      margin-top 2px
                      color #FA5A00
                      cursor pointer
              .circle
                width 20px
                height 20px
                background linear-gradient(0deg, #FF7B33, #FF844E)
                border 1px solid #FFFFFF
                box-shadow 0px 5px 5px 0px rgba(255, 124, 55, 0.3)
                border-radius 50%
                display flex
                align-items center
                justify-content center
                font-size 13px
                color rgba(255, 250, 236, 1)
                text-shadow 0px 3px 3px rgba(233, 95, 24, 0.5)
                cursor pointer
                margin 0 auto 2px
                &.status0
                  box-shadow none
                  text-shadow none
                  background: linear-gradient(0deg, #A0A0A0, #D9D9D9);
              .time
                font-size 12px
                color #FA5A00
                text-align center
                &.status0
                  color #BCBDC1
          .line
            position absolute
            top 50%
            left 50px
            transform translate(0, -11px)
            height 8px
            
            background linear-gradient(0deg, #74C321 0%, #BBEB89 100%)
            border-radius 4px 0px 0px 4px
</style>